<section>
  <header>
    <h1 auto="planning-step4-title">Planning Phase</h1>
  </header>
  <div class="information-container">
    <div>
      <p><strong>Develop Annual Plan</strong></p>
      <p>
        To begin constructing an Annual Improvement Plan, first prioritize your Critical Initiatives. Use the Strategy Map as a reference, and consider what you want to accomplish in the coming year. Once you have prioritized the Critical Initiatives, generate your Annual Improvement Plan by selecting the start and end dates for the coming year. Then, select the <strong>Output</strong> icon.
      </p>
    </div>
    <div class="explanation-margin">
      <div class="download-guide-container">
        <img class="book-icon pointer" src="assets/images/download-guide-icon.svg" alt="book-icon" (click)="openGuide()">
        <span class="download-tagline pointer" (click)="openGuide()">Download the guide</span> to learn more about <strong>Developing Annual Plan</strong>.
      </div>
    </div>
  </div>

  <ng-container *ngIf="!planHasPriorities">
    <div class="empty-message">
      <h1>
        <span class="text">To begin this subphase, complete the Envisioning phase first.</span>
      </h1>
    </div>
  </ng-container>

  <ng-container *ngIf="planHasPriorities && !planHasInitiatives">
    <div class="empty-message">
      <h1>
        <span class="text">In order to begin this subphase, complete the work in your previous subphases.</span>
      </h1>
    </div>
  </ng-container>

  <ul *ngIf="planHasPriorities && planHasInitiatives">
    <li *ngFor="let priority of objectivePriorities">
      <h2 [style.background-color]="priority.colorCode">{{priority.title}}</h2>
      <ng-container *ngFor="let objective of priority.objectives"> <!--objective loop -->
        <ng-container *ngIf="objective.initiatives.length > 0">
          <div class="objective-header" [style.border-left-color]="priority.colorCode"><!-- objective row  -->
            <!-- text cell -->
            <div class="objective-text">
              <h4>Objective</h4>
              <div>{{ objective.text }}</div>
            </div>
          </div><!-- end of objectives row -->

          <ng-container *ngFor="let initiative of objective.initiatives; let i = index;">
            <div class="initiatives-row"><!-- initiatives row -->
              <!-- color cell -->
              <div class="initiatives-color-cell"></div>
              <!-- text cell -->
              <div class="initiatives-text" [ngClass]="{initiativesNotFirst: i !== 0}">
                <h4>Critical Initiative</h4>
                <div class="hard-break-text">{{initiative.description}}</div>
              </div>
              <!-- button cell -->
              <div class="initiatives-buttons-cell" [ngClass]="{initiativesNotFirst: i !== 0}">
                <h6>Select Date</h6>
                <form class="standard-form">
                  <div class="date-container">
                    <p-calendar #startDate
                                auto="dev-annual-plan-start-date"
                                styleClass="strategies-calendar priorities-calendar"
                                inputStyleClass="standard-input"
                                placeholder="Start Date"
                                [showIcon]="true"
                                [ngModelOptions]="{standalone: true}"
                                [disabled]="isEditItemDisabled"
                                [(ngModel)]="initiative.startDate"
                                [maxDate]="initiative.endDate"
                                (onFocus)="resetCalendarEventBlocker()"
                                (onInput)="allowCalendarBlurEvent()"
                                (onSelect)="onChangeDate($event, initiative)"
                                (onBlur)="onChangeDate($event, initiative)">
                    </p-calendar>
                  </div>
                  <div class='date-container'>
                    <p-calendar #endDate
                                auto="dev-annual-plan-end-date"
                                styleClass="strategies-calendar priorities-calendar"
                                inputStyleClass="standard-input"
                                placeholder="End Date"
                                [showIcon]="true"
                                [ngModelOptions]="{standalone: true}"
                                [disabled]="isEditItemDisabled"
                                [(ngModel)]="initiative.endDate"
                                [minDate]="initiative.startDate"
                                (onFocus)="resetCalendarEventBlocker()"
                                (onInput)="allowCalendarBlurEvent()"
                                (onSelect)="onChangeDate($event, initiative)"
                                (onBlur)="onChangeDate($event, initiative)">
                    </p-calendar>
                  </div>
                  <div class="date-error" *ngIf="!datesAreValid(initiative.startDate, initiative.endDate)">
                    <i class="fa fa-exclamation-triangle"></i>
                    <span>Select an end date that is after the start date.</span>
                  </div>
                </form>
              </div>
            </div><!-- end of initiatives header row -->
            <div class="dual-tables-container">
              <div class="outcomes-container">
                <p-table [value]="initiative.outcomes" styleClass="keymeasures-table">
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="1" class="ui-table-empty-message">
                        No Intended Outcomes Created
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="header">
                    <tr>
                      <th>Intended Outcome(s)</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-outcome>
                    <tr>
                      <td class="break-text">{{outcome.outcome}}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
              <div class="keymeasures-container">
                <p-table [value]="initiative.keyMeasures" styleClass="keymeasures-table">
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="1" class="ui-table-empty-message">
                        No Key Measure(s) Created
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="header">
                    <tr>
                      <th>Key Measure(s)</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-keyMeasure>
                    <tr>
                      <td class="break-text">{{keyMeasure.measure}}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div><!-- end of dual tables container -->
          </ng-container><!-- end of critical initiatives loop -->
        </ng-container>
      </ng-container> <!-- end of objectives loop -->
    </li>
  </ul>
</section>
